<template>
    <div class="settings-options alt-units-selector">
        <div class="settings-options-group">
            <span
                class="settings-option btn btn-3d"
                :class="{['selected']: settings.altUnits}"
                @click="() => toggleAlternativeUnits()"
            >
                Alternative units <span
                        class="more-info"
                        @click="onToggleAltUnitsModal"
                    ><fa-icon icon="question-circle" class="fa-regular more-info-icon" /></span>
            </span>
        </div>
        <div v-if="settings.altUnits">
            <div class="settings-options-group alt-unit-types">
                <div class="alt-unit-type-option">
                    <unit-toggle
                        :unitType="altFootman ? UNIT_TYPE_VANGUARD : UNIT_TYPE_FOOTMAN"
                        :checked="altFootman"
                        :callback="() => onToggleAltUnitType('Footman')"
                    />
                </div>
                <div class="alt-unit-type-option">
                    <unit-toggle
                        :unitType="altLancer ? UNIT_TYPE_HEAVY_CAVALRY : UNIT_TYPE_LANCER"
                        :checked="altLancer"
                        :callback="() => onToggleAltUnitType('Lancer')"
                    />
                </div>
                <div class="alt-unit-type-option">
                    <unit-toggle
                        :unitType="altMarshal ? UNIT_TYPE_WARLORD : UNIT_TYPE_MARSHAL"
                        :checked="altMarshal"
                        :callback="() => onToggleAltUnitType('Marshal')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    UNIT_TYPE_ROYAL_GUARD,
    UNIT_TYPE_ROYAL_GUARD_NOBILITY,
    UNIT_TYPE_HEAVY_CAVALRY,
    UNIT_TYPE_VANGUARD,
    UNIT_TYPE_WARLORD,
    UNIT_TYPE_FOOTMAN,
    UNIT_TYPE_LANCER,
    UNIT_TYPE_MARSHAL,
} from '../Unit/Unit-types';

export default {
    props: ['onToggleAltUnitType', 'onToggleAltUnitsModal', 'settings'],
    name: 'AltUnitsSelector',
    created() {},
    data() {
        return {
            ['UNIT_TYPE_ROYAL_GUARD']: UNIT_TYPE_ROYAL_GUARD,
            ['UNIT_TYPE_ROYAL_GUARD_NOBILITY']: UNIT_TYPE_ROYAL_GUARD_NOBILITY,
            ['UNIT_TYPE_HEAVY_CAVALRY']: UNIT_TYPE_HEAVY_CAVALRY,
            ['UNIT_TYPE_VANGUARD']: UNIT_TYPE_VANGUARD,
            ['UNIT_TYPE_WARLORD']: UNIT_TYPE_WARLORD,
            ['UNIT_TYPE_FOOTMAN']: UNIT_TYPE_FOOTMAN,
            ['UNIT_TYPE_LANCER']: UNIT_TYPE_LANCER,
            ['UNIT_TYPE_MARSHAL']: UNIT_TYPE_MARSHAL,
        };
    },
    computed: {
        altRoyalGuard() {
            return this.settings.royalGuardType === UNIT_TYPE_ROYAL_GUARD_NOBILITY;
        },
        altFootman() {
            return this.settings.altFootman;
        },
        altLancer() {
            return this.settings.altLancer;
        },
        altMarshal() {
            return this.settings.altMarshal;
        },
        gameState() {
            return this.$store.state.gameState;
        },
    },
    methods: {
        toggleAlternativeUnits() {
            this.$store.dispatch('setAltUnits', !this.settings.altUnits);
        },
    },
};
</script>
<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .alt-units-selector {

        .settings-explanation {
            margin: 10px 0;
        }

        .settings-options-group {
            display: flex;
            justify-content: space-evenly;

            &.alt-unit-types {
                display: flex;
                justify-content: space-evenly;
                margin-bottom: 15px;
				padding-top: 15px;
            }

            .settings-option {
                background: white;
                border-radius: 4px;
                border: 1px solid $light-gray;
                color: $medium-gray;
                cursor: pointer;
                flex-grow: 1;
                font-size: .9em;
                font-weight: normal;
                margin: 0 4px;
                padding: 5px 10px;
                position: relative;
                text-align: center;
                user-select: none;

                .settings-option-caption {
                    font-size: .65rem;
                    margin-top: 5px;
                }

                &.selected {
                    color: $dark-gray;
                    border: 1px solid $gray;
                    box-shadow: 0 2px $gray;

                    .new-badge {
                        opacity: 1;
                    }

                    &:hover {
                        top: 0;
                        box-shadow: 0 2px $gray;
                    }

					.more-info {
						color: $gray;
					}
                }

                &.limitation {
                    border: 1px solid $lancer;
                    box-shadow: 0 2px $lancer;
                    color: $lancer;

                    &:hover {
                        top: 0;
                        box-shadow: 0 2px $lancer;
                    }
                }

                &:first-of-type {
                    margin-left: 0;
                }

                &:last-of-type {
                    margin-right: 0;
                }

                .new-badge {
                    background: $green;
                    border-radius: 8px;
                    color: white;
                    font-size: .65rem;
                    margin-left: 14px;
                    opacity: .65;
                    padding: 2px 4px;
                    position: absolute;
                    right: 7px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .btn {

            &.btn-3d {
                box-shadow: 0 2px $light-gray-alt;

                &:hover {
                    top: 1px;
                    box-shadow: 0 1px $light-gray-alt;
                }
            }
        }

        .more-info {
			cursor: pointer;
			user-select: none;
			color: $medium-gray;
        }
    }

</style>
